<ng-container *ngIf='business; else noBusiness'>
<div class="mb-3">
    <h1 class="m-0">Update Business Profile</h1>
    <p class="m-0 text-muted">Manage your business details, advertising, analytics and customer activity.</p>
</div>

<div *ngIf="isPending()" class="pending-business-banner mb-4" role="status">
    <div>
        <span class="pending-status">Pending</span>
        <h2>Business is in review or awaiting payment.</h2>
    </div>
    <button mat-raised-button color="primary" class="text-white" (click)="completePayment()">
        Complete payment
    </button>
</div>

<mat-tab-group [selectedIndex]="selectedTabIndex" (selectedIndexChange)="selectedTabIndex = $event">
    <mat-tab label="Business Profile">
        <div class="col-md-12 m-0 border-radius-5 justify-content-center p-3 border-primary relative">
              <div class="d-flex flex-wrap mb-3 justify-content-center">
                <!-- <div class="d-flex align-items-center"> -->
                  <div *ngIf="!business.ProfilePicture || business.ProfilePicture?.source === ''" class="initials text-white link" (click)="openProfilePictureDialog()">
                    <fa-icon [icon]="faUser" class="text-white"></fa-icon> 
                  </div>
                  <div *ngIf="business.ProfilePicture && business.ProfilePicture?.source !== ''" class="profile-pic-initials lg link" (click)="openProfilePictureDialog(business.ProfilePicture.source)">
                    <img #profilePic class="img-fluid" [src]="business.ProfilePicture.source"/>
                  </div>
                  <div class="m-3 d-flex justify-content-center flex-column">
                    <h2 class="m-0">{{business.Name}}</h2>
                  </div>
                <!-- </div> -->
              </div>
          </div>
        <app-business-profile [profile]="business"></app-business-profile>
    </mat-tab>
    <mat-tab label="Ads">
        <h2 class="mt-3 mb-0">Ad Settings</h2>
        <p class="mb-3">Configure ad preferences, targeting options, and budget limits.</p>
        <app-ads></app-ads>
    </mat-tab>
    <mat-tab label="Analytics">
        <h2>Analytics</h2>
        <p>See performance metrics.</p>

        <h2>Favorited By</h2>
        <p>List of customers that added the business to their favorites.</p>
        <div *ngFor="let favorite of favoritedBy; index as i" class="mb-3">
          <h4 class="m-0">{{i+1}}. {{favorite.Name}} {{favorite.Surname}}</h4>
          <p class="m-0">{{favorite.Email}}</p>
          <p class="m-0">{{favorite.Mobile}}</p>
        </div>

        <h2>Ads</h2>
        <p>Opened: Coming soon</p>
        <p>Liked: Coming soon</p>

    </mat-tab>
    <mat-tab label="Chats">
        <h2>Chats</h2>
        <p>View direct chats with customers.</p>

        <app-chat></app-chat>
    </mat-tab>
    <mat-tab label="Leads">
      <h2>Leads</h2>
      <p>View messages sent to business category.</p>
      <div *ngFor="let lead of leads">
        <div class="d-flex flex-column border-primary p-2">
          <p>{{lead.createdAt | date: 'dd MMM yyyy, hh:mm'}}</p>
          <p>&quot;{{lead.Message}}&quot;</p>
            <p class="m-0">{{lead.Sender.Name}} {{lead.Sender.Surname}}</p>
            <p class="m-0">{{lead.Sender.Mobile}}</p>
            <p class="m-0">{{lead.Sender.Email}}</p>
        </div>
      </div>
    </mat-tab>
</mat-tab-group>
</ng-container>
<ng-template #noBusiness>
    <div class="col-md-12 h-100 d-flex justify-content-center align-items-center flex-column">
        <h1 class="text-center">Select one of your businesses in the panel to the left or add a new business</h1>
        </div>
</ng-template>
